import React, { useEffect } from "react";
import { Button, Form } from "antd";
import UserDefaultPermission from "./UserDefaultPermission";
import DashboardFrom from "./components/DashboardFrom";
import MyDocsForm from "./components/MyDocsForm";
import SettingsForm from "./components/SettingsForm";
import ComplianceForm from "./components/ComplianceForm";
import ULPForm from "./components/ULPForm";
import QMSForm from "./components/QMSForm";
import SecretKeyManagerForm from "./components/SecretKeyManagerForm";
import MYPForm from "./components/MYPForm";
import BNFForm from "./components/BNFForm";
import PNAForm from "./components/PNAForm";
import SystemManagerAdminForm from "./components/SystemManagerAdminForm";
import Eform from "./components/Eform";
import {initialValues} from "../../UserPermission/Utils/Utils"
import RoleProjectPermission from "../../RoleManager/RolePermission/RoleProjectPermission";
import RoleIndexPermission from "../../RoleManager/RolePermission/RoleIndexPermission";

const DetailPermissionForm = ({
  formData,
  onFinishFailed,
  onFinish,
  select,
  disabledState = "",
  defaultPermissionOnChange,
  isUserPermission = false,
  selectHmg = [],
  children,
  isAdmin,
  updateInitialValue
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    formData(form);
  }, []);

  const { getFieldValue, setFieldsValue } = form;

  return (
    <div className="is_form_2">
      <Form
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        labelAlign="left"
        initialValues={initialValues}
        labelCol={{
          xxl: { span: 3 },
          xl: { span: 4 },
          lg: { span: 5 },
          md: { span: 5 },
          sm: { span: 5 },
          xs: { span: 24 },
        }}
        wrapperCol={{
          xxl: { span: 21 },
          xl: { span: 20 },
          lg: { span: 19 },
          md: { span: 19 },
          sm: { span: 19 },
          xs: { span: 24 },
        }}
      >
        {isUserPermission && (
          <UserDefaultPermission
            name={select.role_name}
            defaultPermissionOnChange={defaultPermissionOnChange}
          />
        )}
        {isAdmin && <DashboardFrom disabledState={disabledState} />}

        <MyDocsForm
          disabledState={disabledState}
          getFieldValue={getFieldValue}
          setFieldsValue={setFieldsValue}
          idRequired={true}
          isAdmin={isAdmin}
        />
        <SettingsForm
          disabledState={disabledState}
          getFieldValue={getFieldValue}
          setFieldsValue={setFieldsValue}
        />
        <ComplianceForm
          disabledState={disabledState}
          setFieldsValue={setFieldsValue}
          getFieldValue={getFieldValue}
        />
        <ULPForm
          disabledState={disabledState}
          getFieldValue={getFieldValue}
          setFieldsValue={setFieldsValue}
          isAdmin={isAdmin}
        />
        <QMSForm
          disabledState={disabledState}
          getFieldValue={getFieldValue}
          setFieldsValue={setFieldsValue}
          isAdmin={isAdmin}
        />
        {isAdmin && <SecretKeyManagerForm disabledState={disabledState} />}
        <MYPForm
          disabledState={disabledState}
          getFieldValue={getFieldValue}
          setFieldsValue={setFieldsValue}
          isAdmin={isAdmin}
        />
        {/* <BNFForm disabledState={disabledState} /> */}
        <PNAForm disabledState={disabledState} />
        {/* <Eform disabledState={disabledState} /> */}

        {children}
        {selectHmg?.length > 0 && (
          <>
            <RoleProjectPermission
              selectHmg={selectHmg}
              updateInitialValue={updateInitialValue}
            />
            <RoleIndexPermission
              selectHmg={selectHmg}
              updateInitialValue={updateInitialValue}
              getFieldValue={getFieldValue}
              setFieldsValue={setFieldsValue}
            />
          </>
        )}
        <SystemManagerAdminForm
          isAdmin={isAdmin}
          disabledState={disabledState}
          getFieldValue={getFieldValue}
          setFieldsValue={setFieldsValue}
        />

        <div style={{ paddingTop: 20, textAlign: "center" }}>
          <Button type="primary" htmlType="submit">
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default DetailPermissionForm;
